/**
 * La CONFIG de la figure Plotly, hors du composant.
 *
 * `PlotlyChart.vue` ne se monte pas sous jsdom : Plotly touche le canvas et
 * `createObjectURL` dès l'import. La règle qui décide de la barre d'outils et du
 * nom du fichier téléchargé vit donc ici, où elle est lisible et testable, et le
 * composant l'appelle plutôt que de la porter.
 *
 * Deux choses se jouent ici, du point de vue de qui regarde l'écran :
 *
 *  • le bouton de mise à l'échelle automatique réétend l'axe des temps à tout ce
 *    qui est chargé ; sur une page qui PROMET de montrer la fenêtre regardée, il
 *    défait la promesse d'un clic. Un appelant peut demander son retrait sans le
 *    retirer à personne d'autre ;
 *
 *  • le bouton appareil photo télécharge `newplot.png`. Un fichier qui arrive
 *    dans le dossier de téléchargements d'un client est une surface qu'il voit :
 *    il doit porter un nom qui lui parle, et aucun mot interne.
 */

/**
 * Les boutons retirés de la barre d'outils depuis l'origine, dans leur ordre.
 * Tout appelant les perd ; personne n'en a jamais eu d'autre.
 */
export const MODEBAR_BOUTONS_RETIRES = [
    "pan2d",
    "zoomOut2d",
    "zoomIn2d",
    "zoom2d",
    "lasso2d",
    "select2d",
    "resetScale2d",
] as const

export type OptionsConfigPlotly = {
    /** Boutons retirés EN PLUS des sept historiques. */
    modeBarButtonsToRemoveExtra?: string[]
    /** Nom du fichier de l'image exportée, sans extension. */
    toImageFilename?: string
}

/**
 * La config commune à toutes les figures. `modeBarButtonsToAdd` (l'export de
 * données) reste au composant : il porte un rappel et une icône de Plotly.
 */
export function buildPlotlyBaseConfig(
    options: OptionsConfigPlotly = {}
): Record<string, unknown> {
    const config: Record<string, unknown> = {
        responsive: true,
        displaylogo: false,
        locale: "fr",
        modeBarButtonsToRemove: [
            ...MODEBAR_BOUTONS_RETIRES,
            ...(options.modeBarButtonsToRemoveExtra ?? []),
        ],
    }
    if (options.toImageFilename) {
        config.toImageButtonOptions = {
            format: "png",
            filename: options.toImageFilename,
        }
    }
    return config
}
